// /cases/:id — the full-page case. The body lives in components/CaseView.tsx
// and is the same component the dashboard and cases list dock on the right;
// this page is what email links and "Open page" land on, and what phones use.

import { useParams } from 'react-router';
import { CaseView } from '../components/CaseView';

export function CaseDetailPage() {
  const { id } = useParams<{ id: string }>();
  const caseId = Number(id);
  return (
    <div style={{ maxWidth: 960, margin: '0 auto' }}>
      <CaseView key={caseId} caseId={caseId} variant="page" />
    </div>
  );
}
